import { render, staticRenderFns } from "./roomBasic.vue?vue&type=template&id=176d48c0&scoped=true"
import script from "./roomBasic.vue?vue&type=script&lang=js"
export * from "./roomBasic.vue?vue&type=script&lang=js"
import style0 from "./roomBasic.vue?vue&type=style&index=0&id=176d48c0&prod&lang=scss&scoped=true"
import style1 from "./roomBasic.vue?vue&type=style&index=1&id=176d48c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176d48c0",
  null
  
)

export default component.exports